export let tagClassNameMapper: Record<string, string> = {
  'insurance': 'bg-blue-100 text-blue-600',
  'benefits': 'bg-purple-100 text-purple-600',
  'claim-status': 'bg-sky-100 text-sky-600',
  'issues-with-a-bill': 'bg-emerald-50 text-emerald-600',
  'balanced-bill': 'bg-pink-100 text-pink-600',
  'find-a-doctor': 'bg-red-100 text-red-600',
  'other': 'bg-yellow-100 text-yellow-600'
}

export let tagNameMapper: Record<string, string> = {
  'insurance': 'Insurance',
  'benefits': 'Benefits',
  'claim-status': 'Claim Status',
  'issues-with-a-bill': 'Issues with a Bill',
  'balanced-bill': 'Balanced Bill',
  'find-a-doctor': 'Find a Doctor',
  'other': 'Other'
}
